import { SvgIcon, SvgIconProps } from '@material-ui/core'
import useSvgGradient from '@/CustomIcons/useSvgGradients'

export default function HeadphonesWaveIcon({ withGradient, ...rest }: SvgIconProps & { withGradient?: boolean }) {
    const [gradientId, gradientNode] = useSvgGradient()

    return (
        <SvgIcon viewBox="0 0 24 22" {...rest}>
            {withGradient && gradientNode}
            <g clipPath="url(#clip0_1152_44247)">
                <path
                    d="M22.3875 14.2268H21.2891V13.2844C21.2891 13.2684 21.2851 13.2532 21.2843 13.2372L21.2731 10.1284C21.2715 5.00596 17.1187 0.853163 11.9963 0.851563C6.87071 0.849963 2.71471 5.00276 2.71311 10.1284L2.72431 13.162C2.72111 13.2028 2.71151 13.242 2.71151 13.2844V14.2268H1.61311C0.898713 14.2284 0.320312 14.8084 0.320312 15.5228V16.6588C0.321112 17.3724 0.899512 17.9508 1.61311 17.9524H2.71151V18.8972C2.71311 19.9044 3.52991 20.7212 4.53711 20.722H5.16751C6.17471 20.7212 6.99151 19.9052 6.99311 18.8972V13.2844C6.99151 12.2772 6.17471 11.4612 5.16751 11.4596H4.53711C4.22511 11.4596 3.93551 11.546 3.67871 11.6844L3.67311 10.1292C3.67311 5.53396 7.39791 1.80916 11.9931 1.80916C16.5883 1.80916 20.3131 5.53396 20.3131 10.1292L20.3187 11.6828C20.0627 11.5452 19.7747 11.4604 19.4635 11.4596H18.8331C17.8259 11.4612 17.0091 12.2772 17.0075 13.2844V18.8972C17.0091 19.9044 17.8259 20.7212 18.8331 20.722H19.4635C20.4707 20.7212 21.2875 19.9052 21.2891 18.8972V17.9524H22.3875C23.1011 17.9508 23.6795 17.3724 23.6803 16.6588V15.5228C23.6803 14.8084 23.1019 14.2284 22.3875 14.2268Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
                <path
                    d="M8.44094 13.4199C8.17614 13.4199 7.96094 13.6343 7.96094 13.8999V17.4607C7.96094 17.7255 8.17614 17.9407 8.44094 17.9407C8.70574 17.9407 8.92094 17.7255 8.92094 17.4607V13.8999C8.92094 13.6351 8.70574 13.4207 8.44094 13.4199Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
                <path
                    d="M10.2144 11.5645C9.94958 11.5645 9.73438 11.7789 9.73438 12.0445V19.3165C9.73438 19.5813 9.94958 19.7965 10.2144 19.7965C10.4792 19.7965 10.6944 19.5813 10.6944 19.3165V12.0445C10.6944 11.7797 10.4792 11.5653 10.2144 11.5645Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
                <path
                    d="M11.9917 12.916C11.7269 12.916 11.5117 13.1312 11.5117 13.396V17.9664C11.5117 18.2312 11.7269 18.4464 11.9917 18.4464C12.2565 18.4464 12.4717 18.2312 12.4717 17.9664V13.396C12.4717 13.1312 12.2565 12.916 11.9917 12.916Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
                <path
                    d="M13.7613 10.4775C13.4965 10.4775 13.2812 10.6927 13.2812 10.9575V20.4039C13.2812 20.6687 13.4965 20.8839 13.7613 20.8839C14.0261 20.8839 14.2404 20.6695 14.2412 20.4047V10.9575C14.2412 10.6927 14.0261 10.4775 13.7613 10.4775Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
                <path
                    d="M15.5347 13.4199C15.2699 13.4199 15.0547 13.6351 15.0547 13.8999V17.4607C15.0547 17.7255 15.2699 17.9407 15.5347 17.9407C15.7995 17.9407 16.0147 17.7255 16.0147 17.4607V13.8999C16.0147 13.6351 15.7995 13.4199 15.5347 13.4199Z"
                    fill={withGradient ? gradientId : 'currentColor'}
                />
            </g>
            <defs>
                <clipPath id="clip0_1152_44247">
                    <rect
                        width="24"
                        height="20.8"
                        fill={withGradient ? gradientId : 'currentColor'}
                        transform="translate(0 0.466797)"
                    />
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
